module.exports = __webpack_public_path__ + "static/img/news4.6bd3ae9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/news4.png
// module id = shcG
// module chunks = 2